import { Component, input } from '@angular/core';

@Component({
    selector: 'website-wrike-logo',
    templateUrl: './wrike-logo.component.html',
    host: { class: 'header-logo__image' },
})
export class WrikeLogoComponent {
    readonly isDarkTheme = input(false);
}
